module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-controls-wrapper",
    class: {
      'semi-transparent': _vm.isEnabled === false
    }
  }, [_c('div', {
    staticClass: "footer-controls"
  }, [(_vm.inDevelopment()) ? _c('button', {
    staticClass: "seamless-button delete-button",
    on: {
      "click": function($event) {
        _vm.deleteMap()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_outline")])]) : _vm._e(), _vm._v(" "), (_vm.inDevelopment()) ? _c('button', {
    staticClass: "seamless-button reload-button",
    on: {
      "click": function($event) {
        _vm.mapReload()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("replay")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "seamless-button",
    class: {
      'is-atlas': _vm.isAtlasMode
    },
    on: {
      "click": function($event) {
        _vm.mapInfo()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("info_outline")])]), _vm._v(" "), _c('button', {
    staticClass: "seamless-button",
    class: {
      'liked': _vm.isLiked
    },
    attrs: {
      "id": "likeMapIcon"
    },
    on: {
      "click": function($event) {
        _vm.likeMap()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("favorite_border")])]), _vm._v(" "), _c('button', {
    staticClass: "seamless-button",
    attrs: {
      "id": "locateIcon"
    },
    on: {
      "click": function($event) {
        _vm.locate()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("my_location")])]), _vm._v(" "), _c('button', {
    staticClass: "seamless-button",
    attrs: {
      "id": "locateOffIcon"
    },
    on: {
      "click": function($event) {
        _vm.deleteLocate()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("location_off")])]), _vm._v(" "), (_vm.isInIframe) ? _c('button', {
    staticClass: "seamless-button",
    attrs: {
      "id": "launchIcon"
    },
    on: {
      "click": function($event) {
        _vm.launch()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("launch")])]) : _c('button', {
    staticClass: "seamless-button",
    attrs: {
      "id": "homeIcon"
    },
    on: {
      "click": function($event) {
        _vm.home()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("home")])]), _vm._v(" "), _c('button', {
    staticClass: "seamless-button",
    attrs: {
      "id": "shareIcon"
    },
    on: {
      "click": function($event) {
        _vm.share()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-756f4d9f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/footer-controls/footer-controls.vue
// module id = 134
// module chunks = 0